var _path, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 6.89543 0.895431 6 2 6H38C39.1046 6 40 6.89543 40 8V32C40 33.1046 39.1046 34 38 34H2C0.895431 34 0 33.1046 0 32V8Z",
    fill: "#EBECF0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.75,
    cy: 20,
    r: 7,
    fill: "#D82E27"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.25,
    cy: 20,
    r: 7,
    fill: "#EBA23E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 24.6295C21.0891 23.3955 21.75 21.7746 21.75 19.9993C21.75 18.2241 21.0891 16.6031 20 15.3691C18.9109 16.6031 18.25 18.2241 18.25 19.9993C18.25 21.7746 18.9109 23.3955 20 24.6295Z",
    fill: "#EC652B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.f4a051f988310a4e26330382b660eed9.svg";
export { ForwardRef as ReactComponent };